import React, { useEffect, useState } from 'react';
import ProjectDetails from '../ProjectDetails/ProjectDetails';
import Aos from 'aos';
import 'aos/dist/aos.css';

const Projects = () => {
    const [projectsDetails, setProjectsDetails] = useState([]);

    useEffect( () => {
        Aos.init({duration: 1500})
    }, []);

    useEffect(() => {
        fetch('projectsData.json')
            .then(res => res.json())
            .then(data => {
                // console.log(data);
                setProjectsDetails(data);
            })
    }, []);

    return (
        <div className='w-11/12 mx-auto'>
            <div className='flex justify-center items-center'>
                <h2 data-aos='flip-right' className='text-xl mb-5 mt-16  lg:text-4xl font-semibold text-center md:mb-5 border border-blue-600 inline-block rounded rounded-tl-full rounded-br-full px-10 py-2'>Projects</h2>
            </div>
            <div className='grid lg:grid-cols-3 gap-7'>
                {
                    projectsDetails?.map(project => <ProjectDetails
                        key={project._id}
                        project={project}
                    ></ProjectDetails>)
                }
            </div>
        </div>
    );
};

export default Projects;